import { NoteIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'
import { Typography, TypographySizeKeys } from '@/components/ui/typography'
import { PickUnion } from '@/models'

import * as S from './note-alert.styled'

export type NoteAlertProps = {
  text: string
  size?: PickUnion<TypographySizeKeys, 'text-medium' | 'heading-medium'>
}

export const NoteAlert = ({ text, size = 'text-medium' }: NoteAlertProps) => {
  return (
    <S.NoteAlert>
      <Icon icon={NoteIcon} size={size === 'text-medium' ? '2rem' : '2.4rem'} />
      <Typography as="span" size={size} weight="medium" breakLines={4}>
        {text}
      </Typography>
    </S.NoteAlert>
  )
}
